import { Table as Arrow } from 'apache-arrow';
import { useReducer } from 'react';
import { useAsync } from 'react-async-hook';
import { useFeatureFlags } from '../../../../services/featureFlags/hooks/useFeatureFlags';
import { runQuery } from '../util/runQuery';
import { useDuckDb } from './useDuckDb';

/**
 * Execute a SQL query and return the result as Arrow.
 *
 * Wait for DuckDB to initialize if necessary.
 *
 * If sql is undefined, returns undefined.
 *
 * NOTE: This is a hook internal to the duckDB module, do not use
 * this outside of this. Utilize wrapper hooks like useDuckQuery
 */
export const useDuckDbQuery = (
  sql: string | undefined,
  skip: boolean | undefined = false
): {
  arrow: Arrow | undefined;
  loading: boolean;
  error: Error | undefined;
  forceUpdate: () => void;
} => {
  const { Developer } = useFeatureFlags();
  const { db } = useDuckDb();
  const [_forceUpdateToken, forceUpdate] = useReducer((x) => x + 1, 0);

  const {
    result: arrow,
    loading,
    error,
  } = useAsync(async () => {
    if (!db || !sql) {
      return undefined;
    }
    if (skip) return undefined;

    // Log the query to the console in dev mode
    const arrow = await runQuery(db, sql, Developer);
    return arrow;
  }, [db, sql, skip, _forceUpdateToken]);

  return { arrow, loading, error, forceUpdate };
};
